import type { Podpis } from '../api/types.js';
import { formatDatum } from '../lib/format.js';

/** Náhled vlastnoručního podpisu — obrázek + kdo a kdy (razítko dokumentu). */
export function PodpisNahled({ podpis }: { podpis: Podpis }) {
  return (
    <figure className="inline-flex flex-col gap-0.5 rounded-lg border border-border bg-white px-3 py-1.5">
      <img src={podpis.obrazek} alt={`Podpis: ${podpis.jmeno}`} className="h-12 w-auto max-w-40" />
      <figcaption className="border-t border-border pt-0.5 text-xs text-text-secondary">
        {podpis.jmeno}
        {podpis.strana === 'protistrana' ? ' (protistrana)' : ''} · {formatDatum(podpis.createdAt)}
      </figcaption>
    </figure>
  );
}
